<template>
  <WdsStack gap-xs align-center justify-space-between class="tw-max-w-[200px] hire-owners-column">
    <WdsText :text="mainOwner" />
    <WdsTooltip v-if="owners.length > 1" :global="tableGlobals">
      <template #tooltip-content>
        <span v-for="(owner, index) in owners" :key="owner.id">
          {{ `${owner.user.name}${index < owners.length - 1 ? ',' : ''}` }}
          <br />
        </span>
      </template>
      <WdsLabel sm class="tw-whitespace-nowrap">+ {{ owners.length - 1 }}</WdsLabel>
    </WdsTooltip>
  </WdsStack>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsLabel, WdsStack, WdsText, WdsTooltip } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import { useTableGlobalsSelector } from '@/components/GraphqlDataTable/injection'

const tableGlobals = useTableGlobalsSelector()

const PaymentRequestHireOwnersColumnFragment = graphql(`
  fragment PaymentRequestHireOwnersColumn on PaymentRequest {
    id
    hire {
      id
      owners {
        id
        user {
          id
          name
        }
      }
    }
  }
`)

const props = defineProps<{
  row: FragmentType<typeof PaymentRequestHireOwnersColumnFragment>
}>()

const column = computed(() => useFragment(PaymentRequestHireOwnersColumnFragment, props.row))
const owners = computed(() => column.value.hire?.owners ?? [])
const mainOwner = computed(() => owners.value[0]?.user.name ?? $t('No hire owner'))
</script>

<style lang="scss">
.hire-owners-column {
  .wds-text {
    @apply tw-truncate;
    .wds-text-primary {
      @apply tw-truncate;
    }
  }
}
</style>
